import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoalEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Combined Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("g", {
			id: "Final",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M19.696875,10.0401961 C18.996875,10.5946078 18.071875,11.3019608 14.884375,13.6629902 C14.25,14.1345588 13.115625,15.1892157 12,15.1796569 C10.890625,15.1860294 9.778125,14.1536765 9.11875,13.6629902 C5.93125,11.3019608 5.003125,10.5977941 4.303125,10.0433824 C4.178125,9.94460784 4,10.0338235 4,10.1931373 L4,16.7058824 C4,17.5502451 4.671875,18.2352941 5.5,18.2352941 L18.5,18.2352941 C19.328125,18.2352941 20,17.5502451 20,16.7058824 L20,10.189951 C20,10.0338235 19.81875,9.94142157 19.696875,10.0401961 Z M12,14.1568627 C12.725,14.1696078 13.76875,13.2264706 14.29375,12.8377451 C18.440625,9.76936275 18.75625,9.50171569 19.7125,8.7370098 C19.89375,8.59362745 20,8.37058824 20,8.13480392 L20,7.52941176 C20,6.68504902 19.328125,6 18.5,6 L5.5,6 C4.671875,6 4,6.68504902 4,7.52941176 L4,8.13480392 C4,8.37058824 4.10625,8.59044118 4.2875,8.7370098 C5.24375,9.49852941 5.559375,9.76936275 9.70625,12.8377451 C10.23125,13.2264706 11.275,14.1696078 12,14.1568627 Z",
				id: "Combined-Shape",
				fill: "#6D6761"
			})
		})
	]
});
export default SvgIconGoalEmail;
